import { 
  Show, 
  SimpleShowLayout, 
  TextField, 
  ArrayField, 
  SingleFieldList, 
  ChipField,
  useRecordContext,
} from "react-admin";
import { Alert, Box } from "@mui/material";

const SystemRoleAlert = () => {
  const record = useRecordContext();
  if (!record?.systemName) return null;
  
  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="info">
        Este é um perfil do sistema e não pode ser editado.
      </Alert>
    </Box>
  );
};

export const RoleShow = () => (
  <Show actions={false}>
    <SystemRoleAlert />
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="description" emptyText="-" />
      <ArrayField source="permissions">
        <SingleFieldList linkType={false}>
          <ChipField source="description" size="small" />
        </SingleFieldList>
      </ArrayField>
    </SimpleShowLayout>
  </Show>
);
